import React from 'react';
import LoginFormAdmin from '../../authentication/LoginFormAdmin';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import bgImg from 'assets/img/generic/14.jpg';
import Flex from 'components/common/Flex';

const LoginAdmin = () => {
  return (
    <AuthSplitLayout bgProps={{ image: bgImg, position: '50% 20%' }}>
      <Flex alignItems="center" justifyContent="between">
        <h3>Login Administrador</h3>
      </Flex>
      <LoginFormAdmin layout="split" hasLabel />
    </AuthSplitLayout>
  );
};

export default LoginAdmin;
